import type { TFullCommunityApi } from '@/src/features/community/api/communityApi.types'

import { isVirtusCommunity } from '../../community/utils/isVirtusCommunity'

export const withFraternity = (community?: Pick<TFullCommunityApi, 'tags'>): boolean => isVirtusCommunity(community)
